// extracted by mini-css-extract-plugin
module.exports = {"component":"shows_component_17xr0"};